import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useNavigationUtils } from '@mssgme/hooks';
import AuthLayout from '../AuthLayout';
import RegistrationForm from '../Forms/RegistrationForm';

import styles from './styles.scss';

export default function RegistrationPage() {
    const { t } = useTranslation('auth');
    const { generateUrl } = useNavigationUtils();

    return (
        <AuthLayout>
            <div className={styles.root}>
                <div className={styles.header}>
                    <h1>{t('auth.signup.heading')}</h1>
                </div>
                <RegistrationForm />
                <div className={styles.footer}>
                    <span>
                        {t('auth.signin.haveAccount')}{' '}
                        <Link style={{ color: '#007aff' }} to={generateUrl('../login')}>
                            {t('auth.signin.signin')}
                        </Link>
                    </span>
                </div>
            </div>
        </AuthLayout>
    );
}
